
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/2025-10-12-typesafe-routes",
      function () {
        return require("private-next-pages/blogs/2025-10-12-typesafe-routes/index.page.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blogs/2025-10-12-typesafe-routes"])
      });
    }
  